// extracted by mini-css-extract-plugin
export default {"hoverElement":"tooltip_hoverElement__1p88A","tooltip":"tooltip_tooltip__kHd4j"};